import React, { useState, useEffect, useRef } from "react";
import * as th from "./tree_app.js"
import LoginPage from "./pages/login/LoginPage"
import { useSelector } from "react-redux";
import LandingPage from "./pages/login/LandingPage";
import RegisterPage from "./pages/login/RegisterPage";
import AppHeader from "./pages/component/AppHeader";
import AppMenu from "./pages/component/AppMenu";
import AppLoginPage from "./pages/component/AppLoginPage";
import AppRegisterPage from "./pages/component/AppRegisterPage";
import LanguageIcon from '@mui/icons-material/Language';
import TabletAndroidIcon from '@mui/icons-material/TabletAndroid';
import { Box, Button, Grid, Paper, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";

const App = () => {

  const contanerRef = useRef<HTMLDivElement>(null);

  const [switchPage , setSwitchPage] = useState(false);

  const auth = useSelector((state:any)=> state.userInfo.data)

  console.log('auth',auth)

  const nav = useNavigate();

  useEffect(() => {
    // th.start_tree()
  },[]);

  return (
    <Box>
      <Box sx={{ backgroundColor: "#fff", height: "100%", maxWidth: "100%" }}>
        <AppHeader />
        <Box sx={{display: 'flex', justifyContent: "center", padding:"72px"}}>
        <Paper sx={{ margin: "0px", padding: "16px", borderTop: "4px solid #3e36a5"}}>
          <Box sx={{padding:"20px 8px 8px 8px", width:"300px"}}>
            <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "20px", letterSpacing:"-2px"}}>회원가입을 축하합니다.</Box>
            
            <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:600, fontSize: "18px", letterSpacing:"-2px", color:"#586de7"}}>관리자가 권한을 설정한 후 작업이 가능합니다.</Box>
            {/* <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:600, fontSize: "18px", letterSpacing:"-2px", color:"#f50808"}}>로그인 후 "데이터 제출" 페이지에서 샘플을 업로드 해주시기 바랍니다.</Box>
            <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:600, fontSize: "18px", letterSpacing:"-2px", color:"#c33158"}}>로그인 후 "데이터 제출" 페이지에서 샘플을 업로드 해주시기 바랍니다.</Box> */}
            
            {/* <Button variant="contained" sx={{margin:"8px"}} onClick={()=> nav('/')}>로그인</Button> */}
            <Button sx={{marginTop:"16px",width:"80%", height:"38px", magin:"24px", fontSize:"20px", fontWeight:700, color:"#fff", backgroundColor:"#3e36a5",':hover': {bgcolor: '#4caf50', color: 'black'}, letterSpacing:"4px"}} type="button" onClick={()=> nav('/')}>로그인</Button>

            {/* <Button sx={{margin:"24px", fontWeight:700, backgroundColor: "#79b5ef", fontSize: "20px", color: "#fff", padding:"48px"}} ><LanguageIcon fontSize="large" /> 웹 화면 이동</Button>
            <Button sx={{margin:"24px", fontWeight:700, backgroundColor: "#b61e95", fontSize: "20px", color: "#fff", padding:"48px"}} ><TabletAndroidIcon fontSize="large" /> 모바일 화면 이동</Button>
            <Button sx={{padding:"48px"}} >모바일 페이지 이동</Button> */}
          </Box>
        </Paper>
    </Box>
        
      </Box>
    </Box>
    );
}

export default App;
